import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const playlistImporterSelectors = importerSelectors(
  'playlist.importer',
)

export default playlistImporterSelectors
